// TODO this should eventually replace SearchInput.js
import {
  IconButton,
  InputAdornment,
  TextField,
  type TextFieldProps
} from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'

export const SearchField: React.FC<
  Omit<TextFieldProps, 'onChange'> & {
    onChange?(value: string): void
  }
> = ({
  /**
   * See https://github.com/mui/material-ui/issues/22103
   * for guidance on handling of InputProps
   */
  InputProps,
  value = '',
  onChange = () => null,
  variant = 'outlined',
  ...rest
}) => {
  return (
    <TextField
      inputProps={{
        'data-test-search-input': true,
        ...rest.inputProps
      }}
      InputProps={{
        ...InputProps,
        startAdornment: (
          <>
            <InputAdornment position="start">
              <Icon icon="magnifyingGlass" />
            </InputAdornment>
            {InputProps?.startAdornment ?? null}
          </>
        ),
        // this would normally be handled with the `type="search"` prop
        // but I couldn't find a way to change the icon used for the clear button
        endAdornment: (
          <>
            {value && (
              <IconButton
                data-test-clear-search
                aria-label="clear search input"
                size="small"
                sx={{
                  ml: 1,
                  '&.MuiButtonBase-root:hover': {
                    bgcolor: 'transparent'
                  }
                }}
                onClick={() => onChange('')}
              >
                <Icon icon="close" />
              </IconButton>
            )}
            {InputProps?.endAdornment ?? null}
          </>
        )
      }}
      value={value}
      variant={variant}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  )
}
